


require("./js/jquery.js")
require('!style-loader!css-loader!video.js/dist/video-js.css')
require('!style-loader!css-loader!vue-video-player/src/custom-theme.css')
require("!style-loader!css-loader!./bootstrap/css/bootstrap.css");
require("!style-loader!css-loader!./bootstrap/css/font.css");
require("./bootstrap/js/bootstrap.min.js")

import configInfo from "./configInfo.js"
import {wxShareConfig} from './js/common/utils'
import wx from 'wx'
import Vue from 'vue'
import store from './store/index'
import VueRouter from 'vue-router'
import LivePlayer from './views/live_player.vue'



import $ from 'zepto'


import ApiSetting from "./js/common/api.js"
import httpServer from "./js/common/http.js"

import Welcome from './views/welcome.vue'
import Home from './main.vue'
import LeagueOngoing from './views/leagueOngoing.vue'
import LeagueOngoingArrange from './views/leagueOngoing_arrange.vue'
import LeagueOngoingJifen from './views/leagueOngoingJifen.vue'
import LeagueOngoingMoments from './views/leagueMoments.vue'
import LeagueOngoingShooters from './views/leagueShooters.vue'
import LeagueOngoingData from './views/leagueData.vue'

import RoundReport from './views/round_report.vue'
import MomentList from './views/momentList.vue'
import LeagueInfo from './views/LeagueInfo.vue'

import LeagueList from './views/leagueList.vue'
import IndexRegion from './views/index_region.vue'
import PublicIndex from './views/public_index.vue'

import MatchInfo from './views/matchInfo.vue'
import MatchList from './views/matchList.vue'

import MatchInfoShare from './views/matchInfoShare.vue'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'


Vue.directive('title', {
inserted: function (el, binding) {
document.title = el.dataset.title
}
})


Vue.use(DevicePlugin)
Vue.use(LoadingPlugin)
Vue.use(BusPlugin)

Vue.prototype.hagkApi = ApiSetting;
Vue.prototype.hagkHttp = httpServer;

Vue.use(VueRouter)

const routes = [
{
path: '/',
component: Welcome
},
{
path: '/welcome',
component: Welcome
},
{
path: '/index_region',
component: IndexRegion
},
{
path: '/league_ongoing',
component: LeagueOngoing,
children: [
{
path: '/league_ongoing/arrange',
component: LeagueOngoingArrange
},
{
path: '/league_ongoing/jifen',
component: LeagueOngoingJifen
},
{
path: '/league_ongoing/shooters',
component: LeagueOngoingShooters
},
{
path: '/league_ongoing/data',
component: LeagueOngoingData
},
{
path: '/league_ongoing/moments',
component: LeagueOngoingMoments
}
]
},
{
path: '/round_report',
component: RoundReport
},
{
path: '/moment_list',
component: MomentList
},
{
path: '/public_index',
component: PublicIndex
},
{
path: '/home',
component: Home
},
{
path: '/league_info',
component: LeagueInfo
},
{
path: '/live_player',
component: LivePlayer
},
{
path: '/league_list',
component: LeagueList
},
{
path: '/match_info',
component: MatchInfo
},
{
path: '/match_list',
component: MatchList
},
{
path: '/match_info_share',
component: MatchInfoShare
},
{
path: '*',
component: Welcome
}
]


const router = new VueRouter({
mode: 'history',
base: configInfo.routerBase,
routes
})

router.beforeEach((to, from, next) => {
console.log(from.fullPath)
console.log(to.fullPath)
if (from.path == '/league_info') {
to.query.orgCode = from.query.orgCode;
to.query.orgName = from.query.orgName;
}
if (to.path == '/league_list' && from.path == '/league_ongoing') {
to.query.orgCode = configInfo.orgCode;
to.query.orgName = configInfo.orgName;
}
if (to.path == '/index_region' && from.path == '/league_list') {
to.query.regionCode = configInfo.orgCode;
to.query.regionName = configInfo.orgName;
}
next()
});


router.afterEach((to, from, next) => {


var publicShare = true;
if (to.fullPath.indexOf('public_index') >= 0) {
publicShare = false;
} else if (to.fullPath.indexOf('index_region') >= 0) {
publicShare = false;
} else if (to.fullPath.indexOf('league_ongoing') >= 0) {
publicShare = false;
} else if (to.fullPath.indexOf('match_info') >= 0) {
publicShare = false;
} else if (to.fullPath.indexOf('round_report') >= 0) {
publicShare = false;
} else if (to.fullPath.indexOf('league_list') >= 0) {
publicShare = false;
}
if (publicShare) {
console.log("toPath:" + to.fullPath)
var fullPath = window.location.origin + configInfo.routerBase.substr(0, configInfo.routerBase.length - 1) + to.fullPath;
fullPath = fullPath.replace("&from=singlemessage", "");
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
wxShareConfig({
title: '赛事系统',
desc: '来自未来足球赛事系统微信端',
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {

}, () => {

});
}


});

const FastClick = require('fastclick')
FastClick.attach(document.body)

var notNeed = FastClick.notNeeded(document.body);
$.fn.triggerFastClick = function () {
console.log("triger 1");
this.trigger("click");
if (!notNeed) {
console.log("triger 2");
this.trigger("click");
}
}

Vue.config.productionTip = false

const app = new Vue({
store,
router,
created() {

var fullPath = window.location.href;
fullPath = fullPath.replace("&from=singlemessage", "");
fullPath = fullPath.replace("from=singlemessage", "");
if (window.location.href.indexOf('from=singlemessage') > -1) {
window.location.href = fullPath;
} else {
store.commit('updateLandingUrl', fullPath)
console.log(this.$route.fullPath)












if ("/" != this.$route.fullPath) {
window.history.pushState({page: "landing"}, null, router.base);
var that = this;
window.addEventListener("popstate", function (event) {
if (event.state == null) {
that.$router.replace("/welcome");
}
}, false);
this.$router.push(this.$route.fullPath)
}

}

},
methods: {},
render: h => h(Home)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js